<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findLocation"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :disabled="disabled"
            :multiple="multiple"
            :selected-multiple="nodeDetail"
            :prop="prop"
            key-id="_id"
            :key-label="keyLabel"
            :key-sub-label="keySubLabel"
            :param-prepare="paramPrepare"
            :placeholder="placeholder"
            @change="handleChange">
            <!--
              <template #default="{ item }">
              <p
              class="align-middle"
              :class="{ 'font-bold': keySubLabel }">
              {{ item[keyLabel] || $t('labels.invalidData') }}
              </p>
              <p
              v-if="keySubLabel"
              class="align-middle font-light">
              {{ item[keySubLabel] || '' }}
              </p>

              </template>
            -->
            <template #custom>
                <slot name="custom" />
            </template>
        </hts-form-select>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  nodeDetail: { type: Array, default: () => [] },
  prop: { type: String },
  type: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  required: { type: Boolean, default: false },
  nodeTypeId: { type: Boolean, default: false },
  name: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.node') },
  businesses: { type: Object, default: () => {} },
  keyLabel: {
    type: String,
    default: 'locationName'
  },
  keyId: {
    type: String,
    default: '_id'
  },
  locationType: {
    type: String,
    default: ''
  },
  keySubLabel: {
    type: String,
    default: ''
  },
  paramPrepare: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: ''
  },
  api: {
    type: Object || null,
    default: null
  }
})

const { modelValue, type, name, nodeDetail, nodeTypeId, businesses, locationType, keySubLabel, placeholder, api } = toRefs(props)

const information = ref([])
const emits = defineEmits(['update:modelValue', 'update:name', 'update', 'change'])

const cText = computed({
  get () {
    return name.value
  },
  set (val: any) {
    emits('update:name', val)
  }
})

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})

const findLocation = async (s: string) => {
  const a = {
    method: 'get',
    url: '/admincp/node/location/finds'
  }

  const res = await $api(api.value || a, { query: { key: s } })

  const resData: any = res?.data.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
const handleChange = (val: any) => {
  emits('change', val)
}
</script>
